import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

import Util from "@/lib/Util.jsx";
import liveMap from "@/assets/live-map.js";
import Title from "@/components/ui/title/title.jsx";
import useDepartureTimes from "@/components/list-departure-times/use-departure-times.js";
import Alert from "@/components/ui/alert/alert.jsx";

export default function RenderLiveMap({data}) {
  const lineId = data?.[0]?.line_id;
  const scope = data?.[0]?.scope;
  const [content, setContent] = useState(<></>);
  
  const {data: departures, isLoaded} = useDepartureTimes(lineId);
  
  useEffect(() => {
    const processMap = async () => {
      if (lineId && !isLoaded) {
        // É necessário monitorar a mudança da URL, e mudança de id de linha: /lines/:id - algumas linhas não tem mapa atribuído
        // Verificar @/assets/live-map.js
        const existsLinkLiveMap = Object.entries(liveMap).find(item => item[0] === lineId.toString());
        
        const link = existsLinkLiveMap ? existsLinkLiveMap[1] : null;
        
        if (!link) {
          setContent(<></>);
          return;
        }
        
        if (!departures || departures.length === 0) {
          setContent(<></>);
          return;
        }
        
        const uniqueDays = [...new Set(departures.map(d => d.day))];
        const bestMatchIndex = await Util.getBestMatchDayIndex(uniqueDays, scope);
        
        if (bestMatchIndex !== -1) {
          setContent(
            <section id={"mapa"} className={"pt-3"}>
              <div>
                <Title type="h3" classX={" pb-2 text-body-secondary"}>Mapa ao vivo da linha</Title>
                
                <div className={"d-flex flex-column gap-2"}>
                  <Alert variant={"info"} className={"m-0"}>
                    <span>Para consultar o mapa ao vivo da linha é necessário{" "}</span>
                    <Link
                      to={link}
                      rel={"noreferrer noopener"}
                      target={"_blank"}
                      className={"text-info-emphasis fw-semibold"}
                    >
                      <span>acessar o website do Mobilibus</span>
                    </Link>.
                  </Alert>
                  
                  <div className={"d-flex"}>
                    <Link
                      className={"btn btn-primary d-flex gap-1 align-items-center mt-2"}
                      style={{textDecoration: 'none'}}
                      to={link}
                      rel={"noreferrer noopener"}
                      target={"_blank"}
                    >
                      <span className={""}>Abrir website</span>
                      <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill={"currentcolor"}>
                        <path
                          d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </section>
          );
        }
        
        //
        else setContent(<></>);
      }
    };
    
    processMap().then();
  }, [lineId, isLoaded, departures, scope]);
  
  return content;
}

RenderLiveMap.propTypes = {
  data: PropTypes.array
}
